'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _RequiredOnboardingSelectors = require('pricing-pages-unified-ui/selectors/RequiredOnboardingSelectors');

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

var _RequiredOnboardingSection = require('pricing-pages-unified-ui/components/calculator/RequiredOnboardingSection');

var _RequiredOnboardingSection2 = _interopRequireDefault(_RequiredOnboardingSection);

var _ItemConfigsSelectors = require('pricing-pages-unified-ui/selectors/ItemConfigsSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HubCalcRequiredOnboardingSectionContainer = function HubCalcRequiredOnboardingSectionContainer(_ref) {
  var requiredOnboardingMerchId = _ref.requiredOnboardingMerchId,
      termId = _ref.termId,
      ownsProduct = _ref.ownsProduct;

  if (ownsProduct) return null;

  return _react2.default.createElement(_RequiredOnboardingSection2.default, {
    requiredOnboardingMerchId: requiredOnboardingMerchId,
    activeTermId: termId
  });
};

HubCalcRequiredOnboardingSectionContainer.propTypes = {
  requiredOnboardingMerchId: _react.PropTypes.number,
  termId: _react.PropTypes.number,
  ownsProduct: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId,
      term = _ref2.term;

  return {
    requiredOnboardingMerchId: (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchandiseId),
    ownsProduct: (0, _ProductOwnershipSelectors.ownsProductSelector)(state, merchandiseId),
    termId: (0, _ItemConfigsSelectors.termIdFromTermSelector)(state, term, merchandiseId)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcRequiredOnboardingSectionContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcRequiredOnboardingSectionContainer.js
// module id = 743
// module chunks = 3 4